export default __webpack_public_path__ + "static/media/idan-raichel_veim-tavoi-elai.a1f74c2b.mp3";